import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import PremiumIcon from '@wix/da-ds/pkg/Icons/Premium';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import ActionBarButtonRestriced from '../../../_partials/ActionBarButtonRestriced';
import FreeAndPcpPopover from '../FreeAndPcpPopover';
// TODO: very similar to PcpButtonWithPopover, consolidate
export var DownloadButtonWithPopover = function (_a) {
    var _b;
    var deviation = _a.deviation, onDownload = _a.onDownload, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, iconRef = _a.iconRef;
    var t = useTranslation().t;
    var isBlockedBySubscription = useSubscriptionTier(deviation).isBlockedBySubscription;
    var showMoneyIcon = !((_b = deviation === null || deviation === void 0 ? void 0 : deviation.pcp) === null || _b === void 0 ? void 0 : _b.hasUserPurchased) && isBlockedBySubscription;
    return (React.createElement(ActionBarButtonRestriced, { restrictedActionName: ReferralType.ANON_DOWNLOAD, tooltip: showMoneyIcon ? t('actionbar.pcp') : t('common.download'), renderPopover: function (_a) {
            var closeTooltip = _a.closeTooltip;
            return (React.createElement(FreeAndPcpPopover, { deviation: deviation, closeTooltip: closeTooltip, onDownload: onDownload }));
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviation.deviationId,
            ispaiddownload: 1,
        } },
        React.createElement(ActionBarIcon, { icon: showMoneyIcon ? PremiumIcon : DownloadIcon, iconRef: iconRef })));
};
DownloadButtonWithPopover.displayName = 'DownloadButtonWithPopover';
export default DownloadButtonWithPopover;
//# sourceMappingURL=DownloadButtonWithPopover.js.map